module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/G9odWP/tc-custom/9781418513399.jpg?1701952223169",
      "alt": "This image is the cover for the book Business by the Book"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Business by the Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What would happen if you made your business decisions by the book? "), _c('i', [_vm._v("By the Bible that is.")])]), _c('p', [_vm._v("This updated version of the best-selling "), _c('i', [_vm._v("Business by the Book ")]), _vm._v("offers radical principles of business management that go beyond the Ten Commandments and other biblical maxims.")]), _c('p', [_c('i', [_vm._v("Business by the Book ")]), _vm._v("is a step-by-step presentation of how businesses should be run according to the Creator of all management rules: God.")]), _c('p', [_vm._v("Larry Burkett, founder and president of Christian Financial Concepts, provides business principles from his own experience as well as what God’s Word says on topics such as:")]), _vm._v("Hiring and Firing Decisions Pay Increases and Promotions Management Selection Employee Pay Decisions Borrowing and/or Lending Decisions Forming Corporations and Partnerships Business Tithing Retirement"), _c('p', [_vm._v("Whether you are the owner of a business, a corporate executive, or a manager, this best-selling classic is for you.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Larry Burkett\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0